<template>
  <div class="DataTables ProjectDetailsComponent ">


    <p v-if="!isRevision">{{ lang.infotext_1 }}</p>
    <!-- <LoaderComponent v-if="isData == false"></LoaderComponent> -->

    <span v-if="selectedRevisionRow.length > 0">
      <p>{{lang.infotext_2}}:</p>
      <div :id="id"></div>
      <div class="tree-empty"></div>
      <div v-if="appConf.status.isBasicBundle == false" class="tree-container" id="treeContainer">
        <div :id="'place_' + rev" class="tree-folders"  style="display:none" v-for="(rev, index) in propertiesRevNumbers" :key="index">
          <div class="tree">
            <FoldersTreeComponent :isPending="lastPendingRevision" :lastRevisionHistory="lastRevisionHistory"
              :revisionId="rev" :lang="lang.FolderTree" isCategory="edit"></FoldersTreeComponent>
          </div>
        </div>
      </div>

      <!-- <p v-show="isEdit">{{lang.infotext_2}}:</p> -->

      <!-- <b-form-file v-show="isEdit"
      class="library-files"
      v-model="libraryFiles"

      :placeholder="lang.filesPlaceholder"
      drop-placeholder="Drop file here..."
      multiple
    ></b-form-file> -->
      <!-- <br><br> -->
      <p v-show="isEdit"><b-badge class="badge badge-blue">Request</b-badge> - {{ lang.infotext_Request }}</p>
      <p v-show="isEdit"><b-badge class="badge badge-yellow">Release</b-badge> - {{ lang.infotext_Release }}</p>
      <!-- <p v-show="isEdit"><b-badge class="badge badge-danger">Revision</b-badge> - {{ lang.infotext_Revision }}</p> -->
    </span>
  </div>
</template>
<script>
import LoaderComponent from "@/components/shared/LoaderComponent"
import FoldersTreeComponent from "@/components/shared/FoldersTreeComponent"
import DesignEntryTypes from '@/constants/DesignEntryTypes'
import * as Tools from '@/Tools/Tools'
import { mapGetters } from 'vuex'
import ProjectPropertiesType from "@/constants/ProjectPropertiesType";
export default {
  name: "ProjectDetailsComponent",
  props: {
    lang: Object
  },
  components: {
    FoldersTreeComponent,
    LoaderComponent
  },
  data() {
    return {

      mainTable: "",
      id: "ProjectDetailsComponent",
      properties: [],
      pureProperties: [],
      propertiesRevNumbers: [],
      colorValues: [],
      currentPackage: {},
      packages: {},
      symbolSvg: {},
      place: {},
      currentRevisionId: "",
      libraryFiles: null,
      ProjectTypes: [],
      //listAllRevisionFiles: {},
      //listAllImageTriggers: {},
      projectType: "",
      verCounter: 0,
      designEntryTypes: [

      ]
    }
  },
  computed: {
    ...mapGetters({

      globalSettings: "globalSettings",
      appConf: 'appConf',
    }),
    lastPendingRevision() {
      let trig = false;
      for (let i = 0, lei = this.$store.getters.revisionHistory.length; i < lei; i++) {
        if (this.$store.getters.revisionHistory[i].revisionId == this.propertiesRevNumbers[0].revisionId) {
          if (this.$store.getters.revisionHistory[i].status.display == "pending") {
            trig = true;
            break;
          }
        }
      }
      return trig;
    },
    revisionQuantity() {
      return this.$store.getters.selectedRevisionRow.length;
    },
    isEdit() {
      return this.$store.getters.isEditPropertyForm;
    },
    selectedRevisionRow() {
      return this.$store.getters.selectedRevisionRow;
    },
    isData() {
      return this.selectedRevisionRow.length > 0;
    },
    isRevision() {

      return this.$store.getters.selectedRevisionRow.length != 0;

    },
    lastRevisionHistory() {

      if (this.$store.getters.revisionHistory == undefined) {
        return
      }

      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++) {

        if (tab[i].revision > obj.revision) {
          obj = tab[i];
        }
      }

      return obj;
    },
    selectedLastRevisionRow() {
      if (this.$store.getters.selectedRevisionRow.length == 0) {
        return false;
      }
      return this.$store.getters.selectedRevisionRow[0].revisionId == this.lastRevisionHistory.id;
    },
    variant() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return "light";
      } else {
        return "dark";
      }

    },
    propertyToSaving() {
      return this.$store.getters.propertyToSaving;
    },
  },
  created() {
    this.$store.dispatch("deselectAllRevisionRow");

    let vue = this;


    this.$store.dispatch(this.$store.getters.sectionPrefix + "_getProjectType")
      .then(function (result) {

        console.log(result)

        if (result.status == "OK") {

          vue.ProjectTypes = [""];
          result.data.forEach(element => {
            vue.ProjectTypes.push(element.type);
          });

        }
      })


    this.loadDataForRevisions();

    this.$store.dispatch("setSaveStatus", false);

  },
  watch: {

    isEdit: function () {


      this.loadDataForRevisions();
    },
    verCounter: function (newVal) {

      //this.resetTreeContainer();

      if (newVal == this.revisionQuantity) {


        if (this.properties.length != 0) {

          for (let i = 0; i < this.propertiesRevNumbers.length; i++) {
            for (let j = 0; j < this.propertiesRevNumbers.length - i - 1; j++) {
              if (this.propertiesRevNumbers[j] < this.propertiesRevNumbers[j + 1]) {
                const temp = this.propertiesRevNumbers[j + 1];
                const temp2 = this.properties[j + 1];
                this.propertiesRevNumbers[j + 1] = this.propertiesRevNumbers[j];
                this.properties[j + 1] = this.properties[j];
                this.propertiesRevNumbers[j] = temp;
                this.properties[j] = temp2;

              }
            }
          }



          let partsData = [];

          for (let i = 0, lei = this.properties[0].length; i < lei; i++) {
            let objRow = {
              id: this.properties[0][i].id,
              name: this.properties[0][i].name,
              priority: this.properties[0][i].priority,
              type: this.properties[0][i].type,
              isRequiredOnRequest: this.properties[0][i].isRequiredOnRequest,
              isRequiredOnRelease: this.properties[0][i].isRequiredOnRelease,
              isRevisionChanging: this.properties[0][i].isRevisionChanging
            }

            if (this.properties[0][i].type == "project type") {
              this.projectType = this.properties[0][i].value.display;
            }


            for (let j = 0, lej = this.properties.length; j < lej; j++) {


              let revValue = [];
              let isTheSame = [];
              for (let k = 0, lek = this.properties[j].length; k < lek; k++) {

                if (this.properties[j][k].value == null) {

                  this.properties[j][k].value = { display: "", filter: "", sort: "" }

                }


                if (this.properties[0][k].value.display == this.properties[j][k].value.display) {
                  this.properties[j][k].isTheSameLikeLastRev = true;
                } else {
                  this.properties[j][k].isTheSameLikeLastRev = false;
                }

                revValue.push(this.properties[j][k].value);
                isTheSame.push(this.properties[j][k].isTheSameLikeLastRev);
              }


              let key = "value___" + this.propertiesRevNumbers[j];

              objRow[key] = revValue[i];
              objRow.value = revValue[i].display;
              objRow.isTheSameLikeLastRev = isTheSame[i];

            }


            partsData.push(objRow);
          }

          const objFiles = {
            name: "Files",
            id: 1,
            type: "files",
            priority: 999,
            isRequiredOnRelease: false,
            isRequiredOnRequest: false,
            isRevisionChanging: true,
            value: "f",

          }
          for (let j = 0, lej = this.propertiesRevNumbers.length; j < lej; j++) {



            let key = "value___" + this.propertiesRevNumbers[j];
            objFiles[key] = {
              display: "f" + j,
              sort: "f" + j,
              filter: "f" + j
            }
          }


          if (this.appConf.status.isBasicBundle == false) {
            partsData.push(objFiles);
          }


          //this.setDifferentForFiles()
          this.buildTable(partsData)
        }
      }
    },
    selectedRevisionRow: {
      handler: function (newVal, oldVal) {

        if (newVal.length > 0) {


          this.loadDataForRevisions();


        } else {
          this.verCounter = 0;
          this.properties = [];
          this.propertiesRevNumbers = [];
        }
      },
      deep: true


    },


  },

  methods: {
    resetTreeContainer() {
      let treeContainer = document.getElementById("treeContainer");

      while (treeContainer.firstChild) {
        treeContainer.removeChild(treeContainer.firstChild);
      }
    },
    checkIfSaved() {

      let trig = false;
      for (let i = 0, lei = this.properties[0].length; i < lei; i++) {

        if (this.pureProperties[i].value.display != this.propertyToSaving[i].value) {

          trig = true;
        }
      }

      if (trig == true) {
        this.$store.dispatch("setSaveStatus", true)
      } else {
        this.$store.dispatch("setSaveStatus", false)
      }
    },

    loadDataForRevisions() {

      this.verCounter = 0;
      this.properties = []
      this.propertiesRevNumbers = []

      let vue = this;

      for (let i = 0, lei = this.selectedRevisionRow.length; i < lei; i++) {


        let obj = {
          revisionId: this.selectedRevisionRow[i].revisionId,
          revision: this.selectedRevisionRow[i].revision
        }

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_getProject", obj)
          .then(function (result) {

            if (result.status == "OK") {
              result.data.sort(function (a, b) { return a.priority - b.priority });


              vue.properties.push(result.data);
              vue.propertiesRevNumbers.push(result.revision)
              vue.pureProperties = result.data;

              let rev = result.revision;
              vue.verCounter++;

            }



          })

      }

    },
    validateValues(obj) {

      let vue = this;

      let arr = [obj];

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_updateProjectValidation", arr)
        .then((result) => {

          console.log(result);

          if (result.status == "OK") {
            if (result.data.valid == false) {


              for (let i = 0, lei = result.data.violatedRules.length; i < lei; i++) {

                vue.displayValidationRules(result.data.violatedRules[i])
              }
            } else {
              vue.resetValidationRules(obj);
            }
          }



        })


    },
    displayValidationRules(obj) {

      let id = "value__" + obj.propertyId;
      let elem = document.getElementById(id);
      elem.classList.add("warning");

      let idInvalidFeedback = id + "__invalid";
      let elemInvalidFeedback = document.getElementById(idInvalidFeedback);
      elemInvalidFeedback.setAttribute("style", "display: block");
      elemInvalidFeedback.innerHTML = obj.message;

    },
    resetValidationRules(obj) {

      let id = "value__" + obj.propertyId;
      let elem = document.getElementById(id);
      elem.classList.remove("warning");

      let idInvalidFeedback = id + "__invalid";
      let elemInvalidFeedback = document.getElementById(idInvalidFeedback);
      elemInvalidFeedback.setAttribute("style", "display: none");
      elemInvalidFeedback.innerHTML = "";
    },
    checkFormValidationAfterLoad() {


      let editParts = document.getElementsByClassName('edit-part');

      for (var i = 0; i < editParts.length; i++) {

        let temp = editParts[i].id.split("__")

        const validObj = {
          propertyId: temp[1],
          value: editParts[i].value,
        }
        this.validateValues(validObj);


      }

    },
    buildTable(_dataTable) {

      const reloadObj = {
        status: true,
        name: "DelegationsReportComponent",
        source: ""
      }
      this.$store.dispatch("reloadAfterActionComplex", reloadObj);

      if (this.isEdit == true) {

        this.$store.dispatch("resetPropertyToSaving");
        this.$store.dispatch("resetLibraryFilesToSaving");


        for (let i = 0, lei = _dataTable.length; i < lei; i++) {

          if (_dataTable[i].id != 1) {
            let obj = {
              propertyId: _dataTable[i].id,
              value: _dataTable[i].value,
              isRequiredOnRequest: _dataTable[i].isRequiredOnRequest
            }

            this.$store.dispatch("addPropertyToSaving", obj);
          }


        }

      }


      var tableplace = document.getElementById(this.id);

      while (tableplace.firstChild) {
        tableplace.removeChild(tableplace.firstChild);
      }

      var table = document.createElement("table");
      table.setAttribute("id", "t_" + this.id);
      table.setAttribute("style", "width: 100%");
      table.setAttribute("class", "table table-striped table-bordered");
      tableplace.appendChild(table)

      var tr1 = document.createElement("tr");

      var tr2 = document.createElement("tr");

      var thead = document.createElement("thead");
      thead.appendChild(tr1);
      thead.appendChild(tr2);

      table.appendChild(thead);

      let vue = this;


      let cols = [
        { "data": "id" },
        { "data": "priority" },
        { "data": "name" },
      ]

      for (let el in _dataTable[0]) {

        let pos = el.indexOf("value___");
        if (pos > -1) {
          let obj = {
            "data": el
          }
          cols.push(obj);
        }

      }

      let columns = [
        {
          name: "Id",
          alignInColumn: "left",

        },
        {
          name: "Priority",
          alignInColumn: "left",

        },
        {
          name: this.lang.table_header_Name,
          alignInColumn: "left",

        },



      ]

      for (let i = 0, lei = this.selectedRevisionRow.length; i < lei; i++) {
        let obj = {
          name: this.lang.table_header_Value,
          alignInColumn: "left",

        }
        columns.push(obj)
      }


      var columnDefs = [];


      for (var i = 0, len = columns.length; i < len; i++) {

        let classname = '_dt-body-' + columns[i].alignInColumn;

        let el = {
          targets: i,
          className: classname,
          render: function ( data, type, row, meta) {
            if (data == null) {
              return ""
            }
            data = $.fn.dataTable.render.text().display(data);
            if (data.display != undefined) {
              data.display = $.fn.dataTable.render.text().display(data.display);
            }

            if (meta.col == 1) {

              return data;
            }
            if (meta.col == 2) {
              let strName = "<span class=\"name-column\">" + data + "</span>";
              let required = "<span class=\"required\">";
              if (vue.isEdit == true && vue.selectedLastRevisionRow == true) {
                if (row.isRequiredOnRequest == true) {
                  required += "<b-badge class=\"badge badge-blue\">Request</b-badge>";
                }
                if (row.isRequiredOnRelease == true) {
                  required += "<b-badge class=\"badge badge-yellow\">Release</b-badge>";
                }
                // if (row.isRevisionChanging == true) {
                //   required += "<b-badge class=\"badge badge-danger\">Revision</b-badge>";
                // }

                required += "</span>"
              }
              return strName + "   " + required;
            }
            if (meta.col > 2) {


              if (meta.col > 3) {

                let colorClass = "", colorClassImg = "";
                let str = "";
                if (row.isTheSameLikeLastRev == true) {
                  colorClass = "green";
                  colorClassImg = "green-img";
                } else {
                  colorClass = "red";
                  colorClassImg = "red-img";
                }
                let rev = meta.col - 3

                if (row.type == ProjectPropertiesType.TEXT) {


                  str = "<span class=\"" + colorClass + "\">" + data.display + "</span>";
                }
                if (row.type == ProjectPropertiesType.LINK) {

                  str = "<span class=\"" + colorClass + "\">" + data.display + "</span>";
                }

                if (row.type == ProjectPropertiesType.PROJECTNUMBER) {


                  str = "<span class=\"" + colorClass + "\">" + data.display + "</span>";
                }
                if (row.type == ProjectPropertiesType.PROJECTNAME) {


                  str = "<span class=\"" + colorClass + "\">" + data.display + "</span>";
                }
                if (row.type == ProjectPropertiesType.PROJECTTYPE) {


                  str = "<span class=\"" + colorClass + "\">" + data.display + "</span>";
                }
                if (row.type == ProjectPropertiesType.DESIGNENTRYTYPE) {


                  str = "<span class=\"" + colorClass + "\">" + data.display + "</span>";
                }
                if (row.type == ProjectPropertiesType.COMMENT) {


                  str = "<span class=\"" + colorClass + "\">" + data.display + "</span>";
                }
                if (row.type == "files") {

                  if (vue.selectedRevisionRow[rev] != undefined) {
                    str = "<span id=\"value___" + vue.selectedRevisionRow[rev].revisionId + "\"></span>";
                  }

                }


                return str;
              } else {


                if (vue.isEdit == true && vue.selectedLastRevisionRow == true) {

                  let rev = meta.col - 3;
                  if (row.type == ProjectPropertiesType.PROJECTNUMBER) {
                    let str = "";

                    str += "<input disabled=\"disabled\" data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                    str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                    str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                    return str;
                  }
                  if (row.type == ProjectPropertiesType.PROJECTNAME) {
                    let str = "";

                    str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                    str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                    str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                    return str;
                  }
                  if (row.type == ProjectPropertiesType.TEXT) {
                    let str = "";

                    str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                    str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                    str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                    return str;
                  }
                  if (row.type == ProjectPropertiesType.LINK) {
                    let str = "";

                    str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                    str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                    str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                    return str;
                  }
                  if (row.type == ProjectPropertiesType.PROJECTTYPE) {
                    let str = "";

                    str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                    str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                    str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                    return str;
                  }
                  if (row.type == ProjectPropertiesType.COMMENT) {
                    let str = "";

                    str += "<textarea disabled=\"disabled\" data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" type=\"text\" id=\"value__" + row.id + "\" value=\"" + row.value + "\" style=\"resize: none; overflow - y: scroll; height: 50px; \"></textarea>";
                    str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                    return str;
                  }
                  if (row.type == ProjectPropertiesType.DESIGNENTRYTYPE) {
                    let str = "<select class=\"form-control edit-part entry-type-select\" id=\"value__" + row.id + "\">";

                    let tab = ["", DesignEntryTypes.CIS, DesignEntryTypes.HDL];
                    if (vue.appConf.status.isHDL == false) {
                      tab = ["", DesignEntryTypes.CIS];
                    }
                    for (let j = 0, lej = tab.length; j < lej; j++) {

                      let selected = "";
                      if (tab[j] == data.display) {
                        selected = "selected=\"selected\""
                      }
                      str += "<option value=\"" + tab[j] + "\" " + selected + ">" + tab[j] + "</option>";
                    }

                    str += "</select>";
                    str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                    return str;
                  }
                  if (row.type == "files") {
                    let str = "";
                    if (vue.selectedRevisionRow[rev] != undefined) {
                      str = "<span id=\"value___" + vue.selectedRevisionRow[rev].revisionId + "\"></span>";
                    }
                    return str;
                  }

                  return data.display;
                } else {

                  let rev = meta.col - 3
                  if (row.type == "files") {

                    let str = "";
                    if (vue.selectedRevisionRow[rev] != undefined) {
                      str = "<span id=\"value___" + vue.selectedRevisionRow[rev].revisionId + "\"></span>";
                    }
                    return str;
                  }
                  if (row.type == ProjectPropertiesType.LINK) {

                    if (data.display != null) {
                      let link = data.display;
                      let pos = -1;
                      if (vue.globalSettings.displayHttpLinks == true) {

                        pos = link.indexOf("http");

                        if (pos > -1) {
                          return "<a href='" + link + "' target='_blank'>Link</a>";
                        }
                      }
                      if (vue.globalSettings.displayLocalLinks == true) {
                        pos = link.indexOf("\\\\");
                        if (pos > -1) {

                          link = link.split('\\').join('/');

                          link = "file:///" + link
                          return "<a href='" + link + "' target='_blank'>Local link</a>";
                        }
                        pos = link.indexOf("file://");
                        if (pos > -1) {

                          return "<a href='" + link + "' target='_blank'>Local link</a>";
                        }
                      }


                    } else {
                      return "";
                    }
                  }

                  return data.display;
                }

              }


            }

            return data;
          }
        }

        columnDefs.push(el);

        if (i < 4) {
          var th1 = document.createElement("th");
          th1.setAttribute("id", "col" + i);
          th1.setAttribute("style", "width:300px;");
        }

        if (i < 3) {
          th1.setAttribute("rowspan", "2");
        }
        if (i == 3) {
          let colspan = len - i;

          th1.setAttribute("colspan", colspan);
        }


        if (i > 2) {
          var th2 = document.createElement("th");
          let rev = i - 3;
          th2.setAttribute("id", "rev_" + this.selectedRevisionRow[rev].revisionId);
          th2.setAttribute("style", "width:300px;");
        }


        if (i < 4) {
          var p1 = document.createElement("p");

          var tx1 = document.createTextNode(columns[i].name)

          th1.appendChild(tx1);
        }


        if (i > 2) {

          var p2 = document.createElement("p");
          let rev = i - 3;
          var br = document.createElement("br");
          th2.appendChild(br);
          var tx2 = document.createTextNode(this.lang.table_subheader + " " + this.selectedRevisionRow[rev].revision)
          //p2.appendChild(tx2);

        }
        tr1.appendChild(th1);

        if (i > 2) {
          th2.appendChild(tx2);
          tr2.appendChild(th2);
        }


      }


      var json = {};
      json.paging = false;
      json.info = false;
      json.dom = 'f<t>';
      json.data = _dataTable;
      json.myColumnFormats = columns;
      json.select = false;
      json.columns = cols;
      json.columnDefs = columnDefs;
      json.order = [1, "asc"];

      json.initComplete = function () {

        vue.checkFormValidationAfterLoad();
      }

      if ($.fn.dataTable.isDataTable("#t_" + this.id)) {
        this.mainTable.destroy();

      }



      this.mainTable = $('#t_' + this.id).DataTable(json);


      this.mainTable.columns.adjust().draw();

      //hide first column in table
      this.mainTable.column(0).visible(false);
      this.mainTable.column(1).visible(false);

      //search input change view
      var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

      while (searchplace.firstChild) {

        if (searchplace.firstChild.textContent == "Search:") {
          searchplace.removeChild(searchplace.firstChild);
          break;
        }

      }

      searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
      searchplace.firstChild.setAttribute("class", "form-control form-control-sm")



      let editParts = document.getElementsByClassName('edit-part');

      for (var i = 0; i < editParts.length; i++) {
        editParts[i].addEventListener('input', function (e) {

          let temp = this.id.split("__");
          let propertyId = parseInt(temp[1]);
          let type = this.dataset.type;
          let isRequiredOnRequest = this.dataset.isRequiredOnRequest === "true";


          let obj = {
            propertyId: propertyId,
            value: this.value,
            type: type,
            isRequiredOnRequest: isRequiredOnRequest
          }
          const validObj = {
            propertyId: propertyId,
            value: this.value,
          }
          vue.validateValues(validObj);

          vue.$store.dispatch("addPropertyToSaving", obj);

          vue.checkIfSaved();
        })
      }

      for (var i = 0; i < editParts.length; i++) {
        editParts[i].addEventListener('focus', function (e) {

          let temp = this.id.split("__");

          let obj = {
            propertyId: temp[1],
            categoryId: vue.$store.getters.selectedTreeProjectItemObject.categoryId
          }


          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getAutocompleteValues", obj)
            .then((result) => {
              console.log(result)
              let str = "";
              for (let i = 0, lei = result.data.length; i < lei; i++) {
                str += "<option>" + result.data[i] + "</option>";
              }

              let place = document.getElementById("datalist__" + temp[1])
              if (place == null) {
                return
              }
              place.innerHTML = str;


            })
        })
      }






      function trees() {
        for (let i = 0, lei = vue.propertiesRevNumbers.length; i < lei; i++) {
          let tree = document.getElementById("value___" + vue.propertiesRevNumbers[i]);

          if (tree != null) {
            let tree_instance = document.getElementById("place_" + vue.propertiesRevNumbers[i])

            if (tree_instance != null) {

              tree_instance.style.removeProperty('display');

              let a = tree.appendChild(tree_instance);


            } else {
              //tree_instance.style.display = "none";
            }
          } else {
            let tree_instance = document.getElementById("place_" + vue.propertiesRevNumbers[i])

            if (tree_instance != null) {
              tree_instance.style.display = "none";


            }
          }


        }
      }
      setTimeout(trees, 200);



    },

  }

}
</script>
<style lang="scss">
@import "./../../scss/_custom.scss";

.ProjectDetailsComponent {
  table {

    padding: 0px !important;

  }

  table th {
    padding: 0rem !important;

    padding-left: 0.2rem !important;
    padding-right: 0.2rem !important;

  }

  table td {
    padding: 0rem !important;

    padding-left: 0.2rem !important;
    padding-right: 0.2rem !important;

  }

  table.dataTable thead th {
    position: relative;
    background-image: none !important;
  }

  .dataTables_filter {
    font-size: 10px;
  }

  .searcher {
    float: left;
  }

  .dataTables_filter .form-control-sm {
    padding: 0.1rem 0.1rem;
    font-size: 0.7rem;
    line-height: 1;
    width: 200px;
  }

  ._dt-body-left {
    text-align: left;
  }

  ._dt-body-right {
    text-align: right;
  }

  ._dt-body-center {
    text-align: center;
  }

  .red {
    color: $orange;
    //font-weight: 700;
  }

  .blue {
    color: $blue;
    font-weight: 700;
  }

  .yellow {
    color: $yellow;
    font-weight: 700;
  }

  .red-img {
    background-color: $red;
    border: 0px;
  }

  .green {
    color: $lightgreen;
    //font-weight: 700;
  }

  .green-img {
    background-color: $green;
    border: 0px;
  }

  .svg-image {
    background-color: white;
    margin: 10px;
    border: 1px solid #cccccc;
  }

  .btn {
    height: 26px;
  }

  td {
    word-break: break-all;
  }

  input-group {
    min-width: 200px;
  }



  .required {
    float: right;
    margin: 4px;
  }

  .type-select {
    padding-top: 5px;
    font-size: 0.7rem;
    padding-left: 5px;
  }

  .badge {
    margin-right: 3px;
  }

  .button-action-download {
    margin: 2px;
    padding: 0rem 0.5rem;
    height: 22px;
  }
  .entry-type-select{
      padding-top: 5px;
      font-size: 0.7rem;
      padding-left: 5px;
    }
  .tree-folders {
    // width: 400px;

  }

  input::-webkit-calendar-picker-indicator {
    opacity: 0;
  }
  .warning{
    border-color: $redfont !important;
  }
  .invalid{
    color: $redfont;
    font-size: 0.7rem;
    display: none;
  }
  .edit-part{
    margin-top: 3px;
    margin-bottom: 3px;
  }
  .name-column{
    white-space: nowrap;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/shared/ProjectDetailsComponent.vue